// @ts-strict

import { Component, Input } from '@angular/core';
import { StatisticsSummaryService } from '@services/statistics/statistics-summary.service';

@Component({
  selector: 'app-filters-bar',
  templateUrl: './filters-bar.component.html',
  styleUrls: ['./filters-bar.component.scss']
})
export class FiltersBarComponent {
  @Input() appliedFiltersBar: any;

  Object = Object;

  constructor(private statistics: StatisticsSummaryService) {}

  removeSelectedOption(option: any, type: string): void {
    const currentIndex = this.appliedFiltersBar[type].findIndex((singleOption: any) => singleOption.id === option.id);
    this.appliedFiltersBar[type].splice(currentIndex, 1);
    if (this.appliedFiltersBar[type].length === 0) {
      delete this.appliedFiltersBar[type];
    }
    option.type = type;

    if (option.currentParam && type !== 'admin_program_id' && type !== 'program_id') {
      option.type = option.currentParam;
    }
    this.statistics.removeOptionFromBar.next({ appliedFilters: this.appliedFiltersBar, removedOption: option });
  }

  resetAllFilters(): void {
    this.appliedFiltersBar = {};
    this.statistics.resetAll.next();
  }
}
